














































// @ts-ignore
import v8n from 'v8n';
import moment from 'moment';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { ContactSubmission } from '@/api';
import { snackModule } from '@/store';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';

@Component({
  components: { ConfirmDialog },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  message: ContactSubmission | null = null;

  messageDeleteDialog: boolean = false;

  get messageId() {
    return this.$route.params.messageId;
  }

  back() {
    this.$router.back();
  }

  async deleteMessage() {
    if (!this.message) {
      return;
    }
    try {
      await this.message.destroy();
      this.messageDeleteDialog = false;
      this.$router.push({
        name: 'admin-contact',
      });
    } catch (e) {
      // Error
    }
  }

  async mounted() {
    try {
      this.message = (await ContactSubmission.find(this.messageId)).data;
    } catch (err) {
      // most likely this means not found
      snackModule.showSnackbar('Message not found');
    }
  }
}
